import { sendHttpRequest } from "lib/fetcher";

export function getCustomers() {
  return sendHttpRequest({
    method: "get",
    url: "/user/customers?page.limit=100&page.offset=0",
  });
}
export function setCameraPosition(cameraId, position) {
  return sendHttpRequest({
    method: "patch",
    url: `/camera/cameras/${cameraId}/location`,
    data: {
      cameraLocation: position,
    },
  });
}
export function getCameras(siteId, orgId) {
  return sendHttpRequest({
    method: "get",
    url: `/camera/cameras?with_support_inspection=true&siteId=${siteId}&page.limit=600`,
    headers: { "x-org-id": orgId },
  });
}
export function getSiteList(orgId) {
  return sendHttpRequest({
    method: "get",
    url: `/site/tree?withCameraNum=true&withGeolocation=true`,
    headers: { "x-org-id": orgId },
  });
}
